<script setup lang="ts">
import {onMounted, ref, inject, computed} from 'vue'
import type {Config} from '@/types'
import {errorService} from './services/error'
import {ApiService} from "@/services/api";

// Состояние приложения
const isLoading = ref(true);

// Используем реактивное состояние из сервиса
const showErrorModal = computed(() => errorService.errorState.showErrorModal);
const lastErrorMessage = computed(() => errorService.errorState.lastErrorMessage);

// Базовые параметры для работы приложения
const apiService = inject('apiService') as ApiService;
const home_page = (apiService?.getConfig()?.cp_domain)
	? `https://${apiService?.getConfig()?.cp_domain}/`
	: `https://${window.location.host}/`;
const mailto = `mailto:support@grwth.ru?subject=Ошибка%20в%20приложении&body=${encodeURIComponent(window.location.href)}`;


//
// Функции
//

const reloadPage = () => {
	window.location.reload();
}

const goToHomePage = () => {
	window.location.href = home_page;
}

const goToSupportPage = () => {
	window.location.href = mailto;
}

// const showLastErrorMessage = () => {
//	if (showErrorModal.value) return
//	showErrorModal.value = true
// }

// Инициализация приложения
onMounted(async () => {
	try {

		console.log('App.vue: onMounted'); // ---

		// Выключаем блок "for_start" и показываем свой
		[document.getElementById('app')].forEach(($el) => {
			if ($el) $el.removeAttribute('style');
		});
		[document.getElementById('for_start')].forEach(($el) => {
			if ($el && $el.style) $el.style.display = 'none';
		});

	} catch (error) {
		console.error(error);
		// lastErrorMessage.value = error instanceof Error ? error.message : 'Неизвестная ошибка'
		// showLastErrorMessage()
		errorService.showError(error);
	}

	isLoading.value = false;
});
</script>

<template>
<!--	<div id="app" style="display: none;">-->

	<div id="loading" v-if="isLoading">
		<div class="spinner"></div>
	</div>

	<router-view/>

	<div v-if="showErrorModal" class="error-modal">
		<div class="error-modal-content">
			<h2>Произошла критическая ошибка</h2>
			<p>{{ lastErrorMessage || 'Неизвестная ошибка при инициализации приложения' }}</p>
			<div class="error-modal-buttons">
				<button
					class="error-modal-button error-modal-refresh"
					@click="reloadPage"
				>Обновить страницу
				</button>
				<button
					class="error-modal-button error-modal-home"
					@click="goToHomePage"
				>Перейти на главную
				</button>
				<button
					class="error-modal-button error-modal-support"
					@click="goToSupportPage"
				>Написать в поддержку
				</button>
			</div>
		</div>
	</div>

<!--	</div>-->
</template>

<style scoped>
.spinner {
	width: 40px;
	height: 40px;
	border: 3px solid #f3f3f3;
	border-top: 3px solid #3498db;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.error-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999999;
}

.error-modal-content {
	background-color: white;
	padding: 20px;
	border-radius: 5px;
	max-width: 500px;
	width: 90%;
}

.error-modal-buttons {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
	flex-wrap: wrap;
	gap: 10px;
}

.error-modal-button {
	padding: 10px 15px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	flex: 1;
	min-width: 120px;
}

.error-modal-refresh {
	background-color: #3498db;
	color: white;
}

.error-modal-home {
	background-color: #2ecc71;
	color: white;
}

.error-modal-support {
	background-color: #9b59b6;
	color: white;
}
</style>